import { Box, Container, Stack, Text, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <Box color="gray.700" py={8} mt={10}>
      <Container>
        <Stack
          direction={"column"}
        >
          {/* Right Section - Links */}
          <Stack direction={{ base: "column", sm: "row" }} spacing={4}>
            <Button
              variant="link"
            //   color="gray.300"
              _hover={{ color: "#006400" }}
              onClick={() => navigate("/pricing")}
            >
              Pricing
            </Button>
            <Button
              variant="link"
            //   color="gray.300"
               _hover={{ color: "#006400" }}
              onClick={() => navigate("/refundpolicy")}
            >
              Refund Policy
            </Button>
            <Button
              variant="link"
            //   color="gray.300"
               _hover={{ color: "#006400" }}
              onClick={() => navigate("/termsandconditions")}
            >
              Terms & Conditions
            </Button>
            <Button
              variant="link"
            //   color="gray.300"
             _hover={{ color: "#006400" }}
              onClick={() => navigate("/privacyagreement")}
            >
              Privacy Agreement
            </Button>
          </Stack>
          {/* Left Section */}
          <Text fontSize="sm" textAlign="center">
            © {new Date().getFullYear()} Sale Radius. Powered by AI.
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
